var map = {
	"./pl_discover_light.png": 6895,
	"./pl_impact_light.png": 2876,
	"./pl_interests_light.png": 2436,
	"./pl_marketplace_light.png": 8101,
	"./pl_phoneinhand.png": 3037,
	"./pl_projects_light.png": 1734,
	"./pl_tuner_light.png": 7055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7004;